import {autoserializeAs, inheritSerialization} from 'cerialize';
import {BijbModuleTransformer} from '../helpers/enum/bijb-module-transformer';
import {BijbModule} from './bijb-module';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class ModuleSubscription extends ModelBase {
  public static readonly type = 'ModuleSubscription';
  public readonly type = ModuleSubscription.type;

  @autoserializeAs('event_id')
  public eventId: number;

  @autoserializeAs(BijbModuleTransformer, 'module_name')
  public module: BijbModule;

  @autoserializeAs('available')
  public available: boolean;

  @autoserializeAs('enabled')
  public enabled: boolean;
}
